import React from 'react';

function Mozambique(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124043)">
        <mask
          id="mask0_800_124043"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124043)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124043"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124043)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#009933"
            />
            <path
              d="M0 7H-1V8V16V17H0H36H37V16V8V7H36H0Z"
              fill="#272727"
              stroke="white"
              strokeWidth="2"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24L20.25 12L0 0Z"
            fill="#F50100"
          />
          <mask
            id="mask2_800_124043"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="21"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24L20.25 12L0 0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_800_124043)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.07727 14.3532L4.82597 17.4037L6.77601 13.3271L3.42529 10.4588H7.38035L9.00326 7L10.727 10.4588H14.6753L11.1476 13.3271L12.9131 17.4037L9.07727 14.3532Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.9256 11.9842L6.20459 14.1247C6.20459 14.1247 8.63868 14.1033 8.93104 14.3219C9.8119 13.8336 11.6254 14.1247 11.6254 14.1247L10.6608 11.8339C10.6608 11.8339 9.43788 11.3414 8.93104 11.6114C7.68871 11.362 6.9256 11.9842 6.9256 11.9842Z"
              fill="#F7FCFF"
            />
            <path
              d="M13.0094 15.2163C13.1963 15.4369 13.1466 15.7504 12.8984 15.9165C12.6502 16.0826 12.2976 16.0384 12.1107 15.8178L7.4081 10.2666C7.22123 10.046 7.27092 9.73249 7.51909 9.56638C7.76726 9.40027 8.11993 9.44444 8.30681 9.66504L13.0094 15.2163Z"
              fill="black"
            />
            <path
              d="M7.846 9.83974L7.396 9.35974"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.30537 9.36255L4.9458 11.2979L5.62559 12.3446L7.18054 10.2903L7.46022 9.65514L7.18054 9.36255H6.30537Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.54395 15.1085L5.1994 15.9303L10.257 10.6112L10.4668 10.8196L11.6326 9.84468L13.4958 8.043L11.6326 9.39659L11.03 9.24808L10.4668 10.0347H9.90168L5.77059 14.1223L4.54395 15.1085Z"
              fill="black"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124043">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Mozambique;
